<template>
  <div>
    <div style="padding-top: 5px; min-height: calc(100vh - 400px) !important" id="page-container">
      <div class="page-section">
        <div :class="containerClass">
          <div class="category-header d-flex flex-column align-items-start">
            <h2 class="mb-0 text-left">Resources</h2>
            <p
              v-if="getLoggedInUserDashboard !== DASHBOARD_TYPES.ORGANIZATION"
              class="text-left category-desc"
            >
              Access a list of resources provided by your school.
            </p>
          </div>
          <div
            v-if="getLoggedInUserDashboard === DASHBOARD_TYPES.ORGANIZATION"
            class="flex mb-0 w-full"
            style="justify-self: center;"
          >
            <radio-button-group
              :options="listFilterOptions"
              :primary-color="getLoggedInUser.linked_entity.primary_color"
              name="list-filter"
              :modelValue="selectedList"
              @update:modelValue="handleValueChange"
            />
          </div>
          <div v-if="getLoggedInUserDashboard === DASHBOARD_TYPES.ORGANIZATION" class="mb-2">
            <div class="mt-3" style="justify-self: center;" v-if="selectedList === 'resource'">
              Discover tools, guides, and benefit information to unlock new career opportunities and advance your goals.
            </div>
            <div class="mt-3" style="justify-self: center;" v-else>
              Add services to track the personalized support you receive directly from
              {{ this.getLoggedInUser.linked_entity.name }}.
            </div>
          </div>


          <div
            class="d-flex justify-content-center"
            v-if="
              !get(featuredResources, 'length') &&
                !get(staticResources, 'length') &&
                !get(resources, 'length') &&
                !isLoading
            "
          >
            <div class="card card-block card-stretch card-height col-md-8">
              <div class="card-body text-center">
                <i class="fas fa-exclamation-circle fa-lg text-muted mt-4 mb-4" style="font-size: 3rem" />
                <h4>No Resources Found</h4>
                <p class="text-muted">
                  No resources are available at the moment. Please check back later.
                </p>
              </div>
            </div>
          </div>

          <div class="row" v-else :style="{ justifyContent: isMobileScreen ? 'center' : '' }">
            <resource
              :class="!isMobileScreen ? 'mb-3' : ''"
              v-for="resource in featuredResources"
              :key="resource.id"
              :resource="resource"
              @toggle-bookmark="toggleBookmark(resource)"
            />
            <resource
              :class="!isMobileScreen ? 'mb-3' : ''"
              v-for="resource in staticResources"
              :key="resource.id"
              :resource="resource"
            />
            <resource
              :class="!isMobileScreen ? 'mb-3' : ''"
              v-for="resource in resources"
              :key="resource.id"
              :resource="resource"
              @toggle-bookmark="toggleBookmark(resource)"
            />
            <!-- <div class="col-lg-12">
              <div class="card border-1 border-left-3 border-left-primary text-center mb-lg-0">
                <div class="card-body">
                  <b-row no-gutters>
                    <b-col
                      md="5 mb-4"
                      class="rounded bg-secondary"
                      style="box-shadow: 8px 8px 2px 1px rgba(0, 0, 0, 0.2); opacity: 0.85"
                    >
                      <img
                        class="img-responsive"
                        src="@/assets/images/placeholders/1.png"
                        height="125"
                        style="marging-bottom: 100px !important"
                      />
                    </b-col>
                    <b-col md="7">
                      <h3>Sponsorships</h3>
                      <div>Interested in receiving additional funding? Find sponsorships.</div>
                      <router-link
                        class="btn btn-primary setup-guide-btn btn-normal mt-3"
                        style="width: 150px"
                        :to="{ name: 'student-scholarships-listing' }"
                        >Explore</router-link
                      >
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>

            <div
              v-if="get(getLoggedInUser, 'linked_entity.sch_payment_plan.title') === SCH_PAYMENT_PLANS.PAID_PLAN"
              class="col-lg-12 mt-3"
            >
              <div class="card border-1 border-left-3 border-left-primary text-center mb-lg-0">
                <div class="card-body">
                  <b-row no-gutters>
                    <b-col
                      md="5 mb-4"
                      class="rounded bg-secondary"
                      style="box-shadow: 8px 8px 2px 1px rgba(0, 0, 0, 0.2); opacity: 0.85"
                    >
                      <img class="img-responsive" src="@/assets/images/placeholders/2.png" height="125" />
                    </b-col>
                    <b-col md="7">
                      <h3>Discussion Forum</h3>
                      <div>Have questions? Get answers from our discussion forum.</div>
                      <router-link
                        class="btn btn-primary setup-guide-btn btn-normal mt-3"
                        style="width: 150px"
                        :to="{ name: 'student-questions' }"
                        >Ask Question</router-link
                      >
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>

            <div
              v-if="get(getLoggedInUser, 'linked_entity.sch_payment_plan.title') === SCH_PAYMENT_PLANS.PAID_PLAN"
              class="col-lg-12 mt-3"
            >
              <div class="card border-1 border-left-3 border-left-primary text-center mb-lg-0">
                <div class="card-body">
                  <b-row no-gutters>
                    <b-col
                      md="5 mb-4"
                      class="rounded bg-secondary"
                      style="box-shadow: 8px 8px 2px 1px rgba(0, 0, 0, 0.2); opacity: 0.85"
                    >
                      <img class="img-responsive" src="@/assets/images/placeholders/3.png" height="125" />
                    </b-col>
                    <b-col md="7">
                      <h3>Skills Simulation</h3>
                      <div>Ready to show off your skills? Practice skills using video simulation.</div>
                      <router-link
                        class="btn btn-primary setup-guide-btn btn-normal mt-3"
                        style="width: 150px"
                        :to="{ name: 'student-skill' }"
                        >Practice</router-link
                      >
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import PageHeader from '@/components/Ui/PageHeader.vue';
//import { mapActions } from 'vuex';

import { get } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import Page from '@/components/Page.vue';
import { hexToRgb } from '../../../common/utils';
import { DASHBOARD_TYPES, SCH_PAYMENT_PLANS } from '../../../common/constants';
import RadioButtonGroup from '@/components/RadioGroup';

export default {
  components: {
    Resource: () => import('./Resource.vue'),
    RadioButtonGroup,
  },
  extends: Page,
  name: 'Community',
  data() {
    return {
      title: 'Community',

      totalSchools: 0,
      totalStudents: 0,
      totalEmployers: 0,

      isLoading: false,
      resources: [],
      featuredResources: [],
      windowWidth: window.innerWidth,
      SCH_PAYMENT_PLANS,
      DASHBOARD_TYPES,
      selectedList: 'resource',
      listFilterOptions: [
        { text: 'Resource', value: 'resource' },
        { text: 'Service', value: 'service' },
      ],
    };
  },
  watch: {
    selectedList() {
      this.fetchResources();
    },
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser', 'getLoggedInUserDashboard']),
    breadcrumb() {
      return [
        { text: this.$t('home'), to: this.routes.home },
        { text: 'Dashboard', active: true },
      ];
    },
    staticResources() {
      return [];
    },
    isMobileScreen() {
      return this.windowWidth <= 600;
    },
    rgbPrimaryColor() {
      return hexToRgb('red', '#181818');
    },
  },

  methods: {
    ...mapActions('school', ['getAllResources']),
    ...mapActions('organization', ['getOrganizationResources']),
    ...mapActions('student', ['createStudentService', 'deleteStudentService']),
    get,
    handleValueChange(value) {
      this.selectedList = value;
    },
    async toggleBookmark(resource) {
      if (resource.is_service && !resource.is_marked) {
        try {
          const resp = await this.createStudentService({
            organization: this.getLoggedInUser.linked_entity.id,
            service: resource.id,
          });
          if (resp.status === 200) {
            this.makeToast({ variant: 'success', msg: 'Resource marked successfully!' });
            this.fetchResources();
          }
        } catch (error) {
          this.makeToast({ variant: 'danger', msg: 'Resource could not be marked!' });
        }
      } else if (resource.is_service && resource.is_marked) {
        try {
          const resp = await this.deleteStudentService(resource.std_service_id);
          if (resp.status === 200) {
            this.makeToast({ variant: 'success', msg: 'Resource unmarked successfully!' });
            this.fetchResources();
          }
        } catch (error) {
          this.makeToast({ variant: 'danger', msg: 'Resource could not be unmarked!' });
        }
      }
    },
    async fetchResources() {
      this.isLoading = true;
      try {
        let response;
        if (this.getLoggedInUserDashboard === DASHBOARD_TYPES.ORGANIZATION) {
          response = await this.getOrganizationResources({
            org_id: this.getLoggedInUser.linked_entity.id,
            is_service: this.selectedList === 'service',
          });
        } else {
          response = await this.getAllResources({});
        }
        this.resources = response.data.filter(resource => !resource.is_featured);
        this.featuredResources = response.data.filter(resource => resource.is_featured);
      } catch {
        // TODO: Use if needed
      }
      this.isLoading = false;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },

  async mounted() {
    this.fetchResources();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
<style lang="scss" scoped>
.category-header {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.category-desc {
  margin-top: 8px;
  color: #6b7b8f;
}

.back-button {
  background: transparent;
  border: none;
  color: #5e72e4;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 0;
  border-radius: 6px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(94, 114, 228, 0.1);
  }

  ::v-deep .md-icon {
    font-size: 18px !important;
  }
}

.list-filter-btns {
  @media (min-width: 577px) {
    max-width: 250px;
  }
  width: 100%;
}
</style>
